<script setup lang="ts">
import NovaInputText from "@/ui-kit/NovaInputText/NovaInputText.vue";
import FlagLanguageDisplay from "@/features/experience-translation/components/FlagLanguageDisplay.vue";
import DiffText from "@/features/experience-shared/components/DiffText.vue";
import NovaAlert from "@/ui-kit/NovaAlert/NovaAlert.vue";

interface Props {
  commercialName: string;
  offerTitle: string | undefined;
  language: string;
  newValue?: string;
  oldValue?: string;
  hasDiff?: boolean;
  notFound?: boolean;
  readonly?: boolean;
  error?: string;
}

const props = defineProps<Props>();
const modelValue = defineModel<string>();
</script>

<template>
  <div class="bg-white border border-gray-300 rounded-lg p-4 shadow-xs">
    <h2 v-if="props.offerTitle" class="text-sm font-semibold mb-4">{{ props.offerTitle }}</h2>

    <div class="grid grid-cols-2 gap-4">
      <div class="flex flex-col">
        <div class="mb-2">
          <FlagLanguageDisplay country-code="en" />
        </div>
        <div class="bg-white border border-gray-300 rounded-lg p-4 shadow-xs flex-1">
          <NovaInputText :model-value="props.commercialName" :readonly="true">
            <DiffText v-if="hasDiff" :old-value="props.oldValue || ''" :value="props.newValue || ''" />
          </NovaInputText>
        </div>
      </div>
      <div class="flex flex-col">
        <div class="mb-2">
          <FlagLanguageDisplay :country-code="props.language" />
        </div>
        <div class="bg-white border border-gray-300 rounded-lg p-4 shadow-xs flex-1">
          <NovaAlert v-if="props.notFound" variant="solid" status="warning">{{
            $t("option-names.translation-not-found")
          }}</NovaAlert>
          <NovaInputText v-else v-model="modelValue" :readonly="props.readonly" :error="props.error" show-metrics />
        </div>
      </div>
    </div>
  </div>
</template>
